const packageJson = require("../package.json");

export const VERSION = "v" + packageJson.version;
